import { useRef, useEffect, KeyboardEvent } from 'react';
import tw from 'twin.macro';

const FlexWrapper = tw.div`flex gap-2 items-center align-middle`;
const Wrapper = tw.div`w-fit flex gap-2 items-center align-middle border border-solid border-gray-1 rounded focus-within:outline-none focus-within:border-accent-muted p-1 shadow-dropdown`;
const Input = tw.input`w-auto max-w-[110px] text-[12px] border border-solid border-none bg-transparent text-text-and-icon outline-none focus:outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none disabled:cursor-not-allowed`;
const Button = tw.div`flex items-center justify-center rounded-[3px] bg-page-background text-[8px] text-text-and-icon font-semibold px-[4px] py-[3px] cursor-pointer`;

interface IDurationInputProps {
  value?: string;
  focus?: boolean;
  onPressEnter?: (val: number) => void;
  contentEditable?: boolean;
}

export const DurationInput = ({
  value,
  focus,
  onPressEnter,
  contentEditable = true,
}: IDurationInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handlePressEnter = () => {
    if (!inputRef.current || !onPressEnter || !contentEditable) return;

    onPressEnter(Number(inputRef.current.value) * 60);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    const key = event.key;
    if (!inputRef.current || !onPressEnter || !contentEditable || key !== 'Enter') return;

    onPressEnter(Number(inputRef.current.value) * 60);
  };

  useEffect(() => {
    if (value && inputRef.current) {
      inputRef.current.value = String(Math.round(Number(value) / 60));
    }
  }, [value, inputRef]);

  useEffect(() => {
    if (focus) {
      inputRef.current?.focus();
    }
  }, []);

  return (
    <FlexWrapper>
      <Wrapper>
        <Input
          min='1'
          step='1'
          type='number'
          id='minutes-input'
          ref={inputRef}
          disabled={!contentEditable}
          onKeyDown={handleKeyDown}
          placeholder='Duration in minutes'
        />
        <Button onClick={handlePressEnter}>Enter</Button>
      </Wrapper>
    </FlexWrapper>
  );
};
